module.exports = __webpack_public_path__ + "media/img/pages/companies/schott-372a11ad713c2be5087b4649f868b58b.png";